import React, { PureComponent } from 'react';
import { IMAGES_REPO } from '../../../config';

export default class SectionTypeImage extends PureComponent {

  render() {
    const { image } = this.props;
    return (
      <div className="section-type-image">
        <div className="section-type-image__image_container">
          {image && <img className="img" src={`${IMAGES_REPO}${image}`}/>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/type-of-sections/image/index.js